import React, { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import Router from 'next/router';

const HOME_PAGE_QUERY_NAMES = ['LocalData', 'BookmarkIds', 'CompanyName'];

export const ApolloRefetcher: React.FC = () => {
  const client = useApolloClient();

  useEffect(() => {
    const handleRouteChange = url => {
      if (url === '/') {
        requestAnimationFrame(() => {
          client.refetchQueries({ include: HOME_PAGE_QUERY_NAMES });
        });
      }
    };

    Router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [client]);

  return null;
};
